<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
          <ul v-if='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 5px;'>
          <label>الصنف:</label>
          <select @change="changeItemPrice($event.target.value)" class="form-control" style="padding: 0px" v-model="record.item_id">
            <option v-for="item in contractItems" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.item }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 0px;'>
          <div class='col-lg-8 col-sm-8' style='padding:0px; margin:0px'>
          <label>النوع</label>
          <select @change="changeItemPrice($event.target.value)" class="form-control"  style="padding: 0px" v-model="record.type">
            <option v-for="item in price_types" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name}}
            </option>
          </select>
        </div>
        <div class='col-lg-4 col-sm-4' style='padding:0px; margin:0px'>
          <label>المبلغ:</label>
          <input :disabled="contractOfferId > 0" @keypress="isNumber($event)"  v-model='record.amount' class='form-control' name='amount' type='text'>
        </div>
      </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 5px 0px 0px;'>
          <label>الخزنة:</label>
          <select :disabled="contractOfferId > 0" class="form-control" style="padding: 0px" v-model="record.treasury_id">
            <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
              {{ treasury.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 10px 10px 0px;'>
          <label>المخزن:</label>
          <select class="form-control" style="padding: 0px" v-model="record.store_id">
            <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
              {{ store.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-1 col-sm-1' style='padding: 10px 0px 10px 0px;'>
          <label>الايصال:</label>
          <input style='padding: 2px;' @keypress="isNumber($event)" v-model="record.delivery_receipt_id" class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 10px 0px;'>
          <label>فنى التسليم:</label>
          <select class="form-control" style="padding: 0px" v-model="record.delivery_technical_id">
            <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
              {{ technical.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 2px 10px 0px;'>
          <tbDate :mytitle='deliveryDate' v-model= 'record.delivery_date' ></tbDate>
        </div>
        <div class='col-lg-1 col-sm-1' style='padding: 10px 5px 10px 1px;'>
          <label>الايصال:</label>
          <input style='padding: 2px;' @keypress="isNumber($event)" v-model="record.installation_receipt_id" class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 6px 0px 10px 0px;'>
          <a @click='duplicate()' style="padding: 0px" class="btn btn-social-icon btn-bitbucket"><i class="fa fa-arrow-left" style="color:green"></i></a>
          <label>فنى التغيير:</label>
          <select class="form-control" style="padding: 0px" v-model="record.technical_id">
            <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
              {{ technical.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 5px 10px 0px;'>
          <tbDate :mytitle='dateTitle' v-model= 'record.change_date' ></tbDate>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 10px 0px;'>
          <label>المدفوع:</label>
          <input :disabled="contractOfferId > 0" @keypress="isNumber($event)" v-model='record.paid' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-10 col-sm-10' style='padding: 10px 10px 10px 0px;'>
          <label>ملاحظات:</label>
          <input  v-model='record.notes' class='form-control' name='notes' type='text'>
        </div>
        <div class='col-lg-4 col-sm-4  col-lg-offset-4  col-sm-offset-4' style='padding: 0px 0px 10px 0px;text-align:center;'>
          <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
          <button v-show="$per.value.saveMaintenance" @click='showForm(0)'  type='button' class='btn btn-primary btn-outline btn-sm'>جديد</button>
          <button v-show="($per.value.saveMaintenance && record.id === 0 ) || ($per.value.editMaintenance && record.id > 0 )" @click='saveData'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
          <button v-show="$per.value.deleteMaintenance" @click='deleteData(selectedrec)' type='button' class='btn btn-outline btn-danger btn-sm'>حذف</button>
          <button v-show="$per.value.deleteMaintenance && record.id > 0" @click='emptyData(selectedrec)' type='button' class='btn btn-outline btn-danger btn-sm'>إفراغ</button>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 0px 0px 10px 10px;'>
          <label>عروض سابقة:</label>
          <select  @change="getOfferRecords($event.target.value)" class="form-control" style="padding: 0px" v-model="contractOfferId">
            <option  v-for="offer in contract_offers" v-bind:key="offer.id"  v-bind:value="offer.id">
              {{offer.date}} => {{offer.offer_name}} [المقدم: {{offer.paid}}]
            </option>
          </select>
        </div>
        <table width='100%' class='table  table-bordered  unselectable' >
          <thead>
            <tr>
              <th style='text-align: center' rowspan=2>الصنف</th>
              <th style='text-align: center' colspan=2>تسليم</th>
              <th style='text-align: center' colspan=2>ت التغيير</th>
              <th style='text-align: center' rowspan=2>المبلغ</th>
              <th style='text-align: center' rowspan=2>المدفوع</th>
              <th style='text-align: center' rowspan=2>ملاحظات</th>
            </tr>
            <tr>
              <th style='padding:2px;text-align: center'>الفنى</th>
              <th style='padding:2px;text-align: center'>التاريخ</th>
              <th style='padding:2px;text-align: center'>الفنى</th>
              <th style='padding:2px;text-align: center'>التاريخ</th>
            </tr>
          </thead>
          <tbody v-show="!$per.value.editMaintenance">
            <tr v-show="showAll || !record.change_date" v-for='record in records' :key='record.id'>
              <td style="padding:3px" align='center'>{{record.item}}</td>
              <td style="padding:3px" align='center'>{{record.delivery_technical}}</td>
              <td style="padding:3px" align='center'>{{record.delivery_date}}</td>
              <td style="padding:3px" align='center'>{{record.technical_name}}</td>
              <td style="padding:3px" align='center'>{{record.change_date}}</td>
              <td style="padding:3px" align='center'>{{record.amount}}</td>
              <td style="padding:3px" align='center'>{{record.paid}}</td>
              <td style="padding:3px" align='right'>{{record.notes}}</td>
            </tr>
          </tbody>
          <tbody v-show="$per.value.editMaintenance">
            <tr v-show="showAll || !record.change_date" :class="{highlight :selectedrec == record.id}"  v-for='record in records' :key='record.id' v-on:click="showForm(record)">
              <td style="padding:3px" align='center'>{{record.item}}</td>
              <td style="padding:3px" align='center'>{{record.delivery_technical}}</td>
              <td style="padding:3px" align='center'>{{record.delivery_date}}</td>
              <td style="padding:3px" align='center'>{{record.technical_name}}</td>
              <td style="padding:3px" align='center'>{{record.change_date}}</td>
              <td style="padding:3px" align='center'>{{record.amount}}</td>
              <td style="padding:3px" align='center'>{{record.paid}}</td>
              <td style="padding:3px" align='right'>{{record.notes}}</td>
            </tr>
          </tbody>
        </table>
        <!-- /.table-responsive -->
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
  .unselectable {
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .highlight {
     background-color: #5A9EF5;
  }
  tr:hover{
     cursor: pointer;
  }
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import Swal from 'sweetalert2'
export default {
  components: {
    tbDate
  },
  name: 'maintenance',
  data () {
    return {
      price_types: [
        {id: 1, name: 'كاش'},
        {id: 2, name: 'قسط'},
        {id: 3, name: 'مستعمل'},
        {id: 4, name: 'ضمان'},
        {id: 5, name: 'هدية'},
        {id: 0, name: 'عرض سابق'}
      ],
      deliveryDate: 'تاريخ التسليم',
      dateTitle: 'تاريخ التغيير',
      validationErrors: '',
      records: {},
      contract_offers: {},
      contractOfferId: '',
      record: {},
      treasuries: {},
      items: [],
      technicals: {},
      stores: {},
      btnTitle: 'عرض الكل',
      showAll: true,
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      selectedrec: null
    }
  },
  computed: {
    contractItems () {
      if (this.items.lenght === 0) {
        return []
      } else {
        return this.items.filter(item => parseInt(item.is_contract) === 0)
      }
    }
  },
  methods: {
    tabSelected () {
      this.getItemPrices()
      let branches = JSON.parse(localStorage.getItem('Branches'))
      let branchId = this.$store.state.customerData.branche_id
      let i = branches.findIndex(x => x.id === parseInt(branchId))
      if (i > -1) {
        this.treasuries = branches[i].treasuries
        this.technicals = branches[i].technicals
        this.stores = branches[i].stores
      }
      this.validationErrors = ''
      this.showForm(0)
      this.contract_offers = {}
      this.contractOfferId = ''
      this.showAll = true
      this.errorShow = false
      this.successShow = false
      this.selectedrec = null
      this.contractOffers()
      this.records = []
    },
    // =====================================================
    getItemPrices () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-branch-item-prices', {
        token: localStorage.getItem('token'),
        branch: this.$store.state.customerData.branche_id
      })
        .then(res => {
          this.isLoadingData = false
          this.items = res.data
        })
    },
    // =====================================================
    contractOffers () {
      this.contractOfferId = ''
      this.contract_offers = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getContractOffers', {
        token: localStorage.getItem('token'),
        contract_id: this.$store.state.customerData.contract_id
      })
        .then(res => {
          this.isLoadingData = false
          this.contract_offers = res.data
          let emptyRec = [{id: 0, offer_name: 'اصناف خارج العرض', date: ''}]
          this.contract_offers.unshift(emptyRec[0])
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ==================================================================
    changeItemPrice () {
      let y = this.items.findIndex(x => x.id === parseInt(this.record.item_id))
      if (y > -1) {
        if (parseInt(this.record.type) === 1) {
          this.record.amount = this.items[y].price
        } else if (parseInt(this.record.type) === 2) {
          this.record.amount = this.items[y].installment_price
        } else if (parseInt(this.record.type) === 3) {
          this.record.amount = this.items[y].warranty_price
        } else if (parseInt(this.record.type) === 4) {
          this.record.amount = 0
        } else if (parseInt(this.record.type) === 5) {
          this.record.amount = 0
        } else {
          this.record.amount = 0
        }
      }
    },
    // ==================================================================
    getOfferRecords (rec) {
      this.records = []
      this.record = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-offer-items', {
        token: localStorage.getItem('token'),
        contract_id: this.$store.state.customerData.contract_id,
        id: rec
      })
        .then(res => {
          this.isLoadingData = false
          this.records = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // =====================================================
    duplicate () {
      this.record.change_date = this.record.delivery_date
      this.record.technical_id = this.record.delivery_technical_id
      this.record.installation_receipt_id = this.record.delivery_receipt_id
    },
    // =====================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // =====================================================
    isLocked: function (evt) {
      evt.preventDefault()
    },
    // =====================================================
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.getOfferRecords(0)
        this.selectedrec = 0
        this.record = {'id': 0, 'item_id': '', 'amount': '', 'paid': '', 'type': '', 'treasury_id': '', 'user_id': '', 'delivery_date': '', 'delivery_technical_id': '', 'technical_id': '', 'store_id': '', 'notes': '', 'balance': 0, 'delivery_receipt_id': '', 'installation_receipt_id': ''}
        this.contractOfferId = 0
      } else {
        this.selectedrec = recID.id
        this.record = recID
        if (recID.contract_offer_id > 0) {
          this.record.type = 0
        }
      }
    },
    // =====================================================
    changeView () {
      this.showAll = !this.showAll
      if (!this.showAll) {
        this.btnTitle = 'عرض الكل'
      } else {
        this.btnTitle = 'عرض الغير منفذ'
      }
    },
    // =====================================================
    saveData () {
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveMaintenance', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        contract_id: this.$store.state.customerData.contract_id,
        item_id: this.record.item_id,
        contract_offer_id: this.record.contract_offer_id,
        default_date: this.record.default_date,
        delivery_date: this.record.delivery_date,
        change_date: this.record.change_date,
        amount: this.record.amount,
        paid: this.record.paid,
        treasury_id: this.record.treasury_id,
        delivery_technical_id: this.record.delivery_technical_id,
        technical_id: this.record.technical_id,
        branch_id: this.$store.state.customerData.branche_id,
        store_id: this.record.store_id,
        type: this.record.type,
        installation_receipt_id: this.record.installation_receipt_id,
        delivery_receipt_id: this.record.delivery_receipt_id,
        customer_id: this.$store.state.customerData.id,
        notes: this.record.notes
      })
        .then(res => {
          this.isLoadingSave = false
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
          this.$store.state.customerData.contract[0].maintenance = res.data.data
          this.records = res.data.data
          this.isLoadingSave = false
          this.errorShow = false
          if (this.record.id !== 0) {
            let r = this.records.findIndex(x => x.id === this.record.id)
            this.record = this.records[r]
            this.showForm(this.record)
            this.selectedrec = this.record.id
          } else {
            this.showForm(0)
          }
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    // ================================================
    emptyData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'empty-maintenance', {
        token: localStorage.getItem('token'),
        id: recID,
        contract_id: this.$store.state.customerData.contract_id,
        customer_id: this.$store.state.customerData.id,
        contract_offer_id: this.contractOfferId
      })
        .then(res => {
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
          this.$store.state.customerData.contract[0].maintenance = res.data.data
          this.records = res.data.data
          this.isLoadingDelete = false
          this.errorShow = false
          this.successShow = false
          this.showForm(0)
        })
        .catch(err => {
          if (err.response.data.errors === 'id not found') {
            this.validationErrors = {errors: 'عفوا يرجى اختيار سجل لحذفه'}
            this.isLoadingDelete = false
            this.errorShow = true
          }
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    // ================================================
    deleteData (recID) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
        .then((result) => {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'deleteMaintenance', {
            token: localStorage.getItem('token'),
            id: recID,
            customer_id: this.$store.state.customerData.id
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف السجل بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
              let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.$store.state.customerData.contract_id)
              this.$store.state.customerData.contract[i].maintenance = res.data.data
              this.records = res.data.data
              this.isLoadingDelete = false
              this.errorShow = false
              this.successShow = false
              this.showForm(0)
            })
            .catch(err => {
              if (err.response.data.errors === 'id not found') {
                this.validationErrors = {errors: 'عفوا يرجى اختيار سجل لحذفه'}
                this.isLoadingDelete = false
                this.errorShow = true
              }
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
            })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/Maintenance.vue